// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-CssProp4_svg-module--cls1--1QOUb","cls2":"index-CssProp4_svg-module--cls2--3VImz index-CssProp4_svg-module--cls1--1QOUb"};